import * as yup from 'yup';

function email(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'EMAIL_FIELD_IS_INVALID',
        defaultMessage: 'Email is invalid',
      }),
    )
    .required(
      formatMessage({
        id: 'EMAIL_FIELD_IS_REQUIRED',
        defaultMessage: 'Email is required',
      }),
    );
}
// eslint-disable-next-line no-unused-vars
function locationEmail(formatMessage) {
  return yup
    .string()
    .transform(value => (value === '' || value == null ? undefined : value))
    .optional()
    .email(
      formatMessage({
        id: 'EMAIL_FIELD_IS_INVALID',
        defaultMessage: 'Email is invalid',
      }),
    );
}

function phones(formatMessage) {
  return yup.array().of(
    yup.object().shape({
      phoneNumber: yup.string().required(
        formatMessage({
          id: 'FIELD_REQUIRED',
          defaultMessage: 'Phone number is required',
        }),
      ),
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      email: email(formatMessage),
      phones: phones(formatMessage),
    })
    .required();

/** Location setup: validate phones only; email is optional but must be valid when set. */
const locationValidationSchema = formatMessage =>
  yup
    .object({
      phones: phones(formatMessage),
      email: locationEmail(formatMessage),
    })
    .required();

export default validationSchema;
export { locationValidationSchema };
